import { Center, Loader } from "@mantine/core";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthStatus } from "../../hooks/useAuthStatus";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStatus();
  const router = useRouter();

  useEffect(() => {
    // Only redirect after auth status is determined
    if (!isLoading && !isAuthenticated) {
      router.navigate({ to: "/login" });
    }
  }, [isAuthenticated, isLoading, router]);

  // Show loading while auth status is being determined
  if (isLoading) {
    return (
      <Center className="min-h-screen">
        <Loader size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return (
      <Center className="min-h-screen">
        <Loader size="lg" />
      </Center>
    );
  }

  return <>{children}</>;
}
